const SESSION_KEYS = [
  "token", "email", "rol", "endpoint", "esSuperAdmin", "perfilId", "tipoCuenta"
];

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const encoded = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "=");
    const payload = JSON.parse(atob(padded));
    return !payload.exp || payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}

export function clearSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new StorageEvent("storage", { key: "token" }));
  window.dispatchEvent(new Event("auth-changed"));
}
